import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { StepInit } from "./StepInit";
import { CpqWrapper } from "./CpqWrapper";

export const NewSale = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <StepInit />
      </Route>
      <Route path={`${path}/cpq`}>
        <CpqWrapper />
      </Route>
    </Switch>
  );
};
